/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DueDate/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import DueDatePicker from './DueDatePicker/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function DueDate({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/DueDate"
  
}) {
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<div
  data-testid="DueDate.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-ZJrfN6': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="DueDate.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral600}
 text="Due Date"
/>
</div>
<DueDatePicker
  viewPath={`${viewPath}/DueDatePicker`}
/>
</div>
{children}
</React.Fragment>)
}